<template>
  <div>
    <Breadcrumb :title="'Investment Upload'"></Breadcrumb>
    <div class="row no-gutters">
      <div class="col">
        <button class="btn btn-primary" style="float:right;" @click.prevent="downloadTemplate">
          <span class="fa fa-download"></span> Download Template
        </button>
        <button
          class="btn btn-secondary"
          style="float:right;margin-right:10px;"
          @click.prevent="backtoInvestment"
        >
          <span class="k-icon k-i-undo"></span> &nbsp;Back to Investment Information
        </button>
      </div>
    </div>
    <div class="row">
      <br />
    </div>
    <BaseAuditDropzone
      :id="'Investment'"
      ref="ParentFileUploaded"
      :acceptedFileTypes="SheetJSFT"
      @change="_change"
      @Remove="ClearForm"
      :File="inputfile"
      :UploadType="FileUploadType"
    ></BaseAuditDropzone>
    <br />
    <br />

    <div id="pageErrors" class="alert alert-danger" v-if="pageErrors.length>0">
      <b>Please correct the following error(s):</b>
      <ul>
        <li v-for="error in pageErrors" :key="error">{{ error }}</li>
      </ul>
    </div>
    <br />

    <div v-show="displayPage">
      <div class="row no-gutters">
        <div class="col">
          <div class="form-row">
            <div class="col-md-12">
              <BaseGrid
                :mode="'editform'"
                :config="InvestmentUploadConfig"
                :data="dataInvestmentExcel"
                @DeleteItem="DeleteDIfromGrid"
              >
                <!-- @EditItem="EditPartner"  -->
              </BaseGrid>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <br />
      </div>
      <div class="row no-gutters" style="float: right;margin-left:15px;">
        <button
          type="button"
          id="btnSave"
          class="btn btn-primary"
          :disabled="(!bValidated || pageErrors.length>0 || dataInvestmentExcel.length<=0)"
          @click.prevent="SaveInvestments"
        >Save</button>
      </div>
      <div class="row no-gutters" style="float: right;">
        <button
          type="button"
          id="btnSave"
          class="btn btn-secondary"
          @click.prevent="validateFn"
        >Validate</button>
      </div>
      <div class="row">
        <br />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import customAxios from "@/services/customAxios.js";
import { getUrl } from "../../configs/assets.js";
import { getFileName } from "../../configs/assets.js";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseDropzone from "@/components/base/BaseDropzone.vue";
import BaseAuditDropzone from "@/components/base/BaseAuditDropzone.vue";
import moment from "moment";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import BasePartner from "@/models/BaseModelPartner.js";
import BaseModelInvestment from "@/models/BaseModelInvestment.js";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import { mapActions, mapState, mapGetters } from "vuex";
import { InvestmentUploadConfig } from "@/views/investment/InvestmentUploadConfig.js";
import XLSX from "xlsx";
import sheetJSConfig from "@/configs/sheetJS.js";
import { isNullOrUndefined } from "util";

import DocumentManagerMixin from "@/mixins/DocumentManagerMixin.js";
import DropZoneGridConfig from "@/models/BaseModelDropZoneGrid.js";
import bulkUploadAuditConfig from "@/models/BaseModelAuditUploadDocument.js";

export default {
  mixins: [apiUtil, funcUtil, DocumentManagerMixin],
  data() {
    return {
      data: "",
      inputfile: {
        UploadFile: {}
      },
      //UploadFile:excelfile,
      displayPage: false,
      FileUploadType: {
        AllowMultiple: "false"
      },
      SheetJSFT: sheetJSConfig.fileType,
      InvestmentUploadConfig: InvestmentUploadConfig,
      dataInvestmentExcel: [],
      pageErrors: [],
      PartnerAPIData: [],
      InvestmentAPIData: [],
      BaseModelInputControl: BaseModelInputControl,
      Columns: [],
      InvestmentGroupOptions: [],
      bValidated: false,
      bulkUploadAuditConfig: bulkUploadAuditConfig
    };
  },
  components: {
    BaseGrid,
    Breadcrumb,
    BaseAuditDropzone
  },
  computed: {
    ...mapState("postModule", ["response"]),
    ...mapGetters("getModule", [
      "withFilter",
      "getAllItemFilter",
      "getLocalInputControls"
    ])
  },
  methods: {
    ...mapActions("postModule", [
      "CreateAllItems",
      "PostAllFilesAndUpdateMetadata",
      "PostAllAuditFilesAndUpdateMetadata"
    ]),
    _suppress(evt) {
      evt.stopPropagation();
      evt.preventDefault();
    },
    downloadTemplate() {
      let token = localStorage.getItem("eum")
           let tokenstr = `Bearer ${token}`
           let templateUrl = getUrl("InvestmentExcel");
           let templateFileName = getFileName("InvestmentExcel");
            
           customAxios({
              url: templateUrl,
              method: 'GET',
              headers: {
                'Authorization': tokenstr
              },
              responseType: 'blob', // important,
            }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', decodeURIComponent(templateFileName));
         document.body.appendChild(link);
              link.click();
            });
    },

    _drop(evt) {
      evt.stopPropagation();
      evt.preventDefault();
      const files = evt.BaseModelTransfer.files;
      if (files && files[0]) {this._file(files[0]);}
    },
    _change(evt) {
      const files = this.inputfile.UploadFile[0];
      if (files) {this._file(files);}
    },
    backtoInvestment: function() {
      this.$router.push("/configuration/investment");
    },
    _export(evt) {
      /* convert state to workbook */
      const ws = XLSX.utils.aoa_to_sheet(this.data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
      /* generate file and send to client */
      XLSX.writeFile(wb, "sheetjs.xlsx");
    },
    _file(file) {
      /* Boilerplate to set up FileReader */
      try {
        const reader = new FileReader();
        reader.onload = e => {
          /* Parse data */
          //const bstr = e.target.result;
          let binary = "";
          let bytes = new Uint8Array(e.target.result);
          let length = bytes.byteLength;

          for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          const bstr = binary;
          const wb = XLSX.read(bstr, {
            type: "binary"
          });
          /* Get Partner  data */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_json(ws, {
            range: sheetJSConfig.template.header - 1,
            header: 1
          });
          console.log(data);
          data.splice(0, 1);
          if (data && data.length) {
            this.displayPage = true;

            let InvestmentExcelArr = [];
            let count = 1;
            for (let i = 0; i < data.length; i++) {
              let InvestmentExcelObj = {};
              InvestmentExcelObj.InvestmentKey = count++;
              //InvestmentExcelObj.PartnerPartnerID = data[i][1];

              InvestmentExcelObj.Title = !isNullOrUndefined(data[i][0])
                ? data[i][0]
                : "";
              InvestmentExcelObj.InvestmentGroup = !isNullOrUndefined(
                data[i][1]
              )
                ? data[i][1]
                : "";
              InvestmentExcelObj.StatementOrder = !isNullOrUndefined(data[i][2])
                ? data[i][2]
                : null;
              InvestmentExcelObj.Note = data[i][3];
              InvestmentExcelObj.ShowOnFMVS = data[i][4];

              InvestmentExcelArr.push(InvestmentExcelObj);
            }
            this.dataInvestmentExcel = InvestmentExcelArr;

            const grid = $("#InvestmentUploadGrid").data("kendoGrid");

            grid.dataSource.data(this.dataInvestmentExcel);
            console.log(JSON.stringify(this.dataInvestmentExcel));
          } else {
            this._AlertPopup("Template is Empty", "error");
          }
        };
        reader.readAsArrayBuffer(file);
      } catch (ex) {
        console.log(ex);
        //this.$Progress.fail();
      }
    },

    getLatestInvestmentID: function() {
      let self = this;
      let InvestmentID = 0;

      // US #1180 : Investment ID
      let result = this.withFilter(BaseModelInvestment.list, "");

      if (result.length <= 0) {
        InvestmentID = 500001;
      } else {
        //let lastElement = _.last(result);
        InvestmentID = self._getIncrementalID(result, "InvestmentID");
      }

      return InvestmentID;
    },

    getInvestmentDetails: function() {
      let Investment = this.InvestmentAPIData.slice();
      let dataInvestmentExcel = this.dataInvestmentExcel.slice();

      for (let i = 0; i < dataInvestmentExcel.length; i++) {
        if (dataInvestmentExcel[i].InvestmentInvestmentID) {
          const result = Investment.filter(function(obj) {
            if (obj.InvestmentID) {
              return (
                obj.InvestmentID.toString()
                  .trim()
                  .toLowerCase() ==
                dataInvestmentExcel[i].InvestmentInvestmentID.toString()
                  .trim()
                  .toLowerCase()
              );
            }
          })[0];
          if (result) {
            dataInvestmentExcel[i].InvestmentTitle = result.Title;
            dataInvestmentExcel[i].InvestmentId = result.Id;
          }
        }
      }
      this.dataInvestmentExcel = dataInvestmentExcel;
    },

    DeleteDIfromGrid: function(e) {
      //e.preventDefault();
      //alert("Delete button clicked from BaseGrid..");

      const message = "Are you sure you want to delete this record?";
      this._ConfirmationPopup(message, "DELETE").then(result => {
        if (result.value) {
          const gview = window.$("#InvestmentUploadGrid").data("kendoGrid");
          const dataItem = gview.dataItem(
            window.$(e.currentTarget).closest("tr")
          );
          //var dataItem = JSON.stringify(window.$(e.currentTarget).closest("tr"));
          //alert(JSON.stringify(dataItem));
          let objIndex = this.dataInvestmentExcel.findIndex(
            obj => obj.InvestmentKey == dataItem.InvestmentKey
          );
          this.dataInvestmentExcel.splice(objIndex, 1);
          const grid = $("#InvestmentUploadGrid").data("kendoGrid");
          grid.dataSource.data(this.dataInvestmentExcel);
        }
      });
    },
    getConfirmation: function() {
      const retVal = confirm(
        "You are about to delete this Investment.Press ok to continue otherwise press cancel."
      );
      if (retVal == true) {return true;}
      else {return false;}
    },
    validateFn(e) {
      let self = this;
      e.preventDefault();
      self.pageErrors = [];
      let errorMessages = new Set();
      self.bValidated = true;
      let dataItem = $("#InvestmentUploadGrid")
        .data("kendoGrid")
        .dataSource.data();

      dataItem.forEach((ele, i) => {
        self.Columns = [];
        //Investment Name
        if (!ele.Title) {
          self.Columns.push({ column: "Title", row: i });
          errorMessages.add("Investment Name is required");
        }

        //Investment Group
        let investGroupIndex = self.InvestmentGroupOptions.findIndex(
          f => f.Option == ele.InvestmentGroup
        );
        if (investGroupIndex < 0) {
          self.Columns.push({ column: "InvestmentGroup", row: i });
          errorMessages.add("Investment Group is Empty or Invalid");
        }

        //Statement Order

        if (!ele.StatementOrder || isNaN(ele.StatementOrder)) {
          self.Columns.push({ column: "StatementOrder", row: i });
          errorMessages.add("Statement Order must be a number");
        }
        //Validation status for a row
        self.Columns.push({ column: "Validation", row: i });
        self.ValidateImportData("InvestmentUploadGrid", self.Columns);
      });
      self.pageErrors = [...errorMessages];
    },

    SaveInvestments: function() {
      const self = this;
      let LatestInvestmentID = this.getLatestInvestmentID();

      this.dataInvestmentExcel.forEach(element => {
        element.InvestmentID = LatestInvestmentID;
        LatestInvestmentID = LatestInvestmentID + 1; // increament the Investment ID
      });

      let NewInvestmentobject = {
        Investment: {
          config: BaseModelInvestment,
          createData: this.dataInvestmentExcel
        }
      };
      //let loader = this.$loading.show();
      self._APICrudPopup("APICrudpopup");
      //this._createAllItems(NewPartnerobject).then(addnewpartner => {
      this.CreateAllItems(NewInvestmentobject)
        .then(Investment => {
          console.log(Investment);
          /** commented becuase audit log should completed before user navigating to other page. */
          // self._AlertPopup("Investment data saved successfully", "success");

          /** AUDIT DOCUMENT UPLOAD **/
          //  let selectedFile = { ...grid.dataItem(this) };
          let FileUpload = [];
          let senderObj = {};
          //senderObj.Id = this.count++;
          let realfileName = this.inputfile.UploadFile[0].name;
         // senderObj.File = self._appendDatewithExcelName(fileName);
          senderObj.File = this.inputfile.UploadFile[0].upload.uuid
          senderObj.RealFileName = realfileName;
          senderObj.BulkUploadType = "Investment Upload";
          senderObj.FileContent = this.inputfile.UploadFile[0];
          FileUpload.push(senderObj);
          this.UploadBulkAditFilesToDB(FileUpload,true)
            .then(response => {
              self._AlertPopup("Investment data saved successfully", "success");
            })
            .catch(error => {
              self._AlertPopup("Some Error Occurred!", "info");
            })
            .finally(() => {
              //loader.hide();
            });
          /** AUDIT DOCUMENT UPLOAD END */

          this.$refs.ParentFileUploaded.$refs.FileUploaded.removeAllFiles();
        })
        .catch(error => {
          self._AlertPopup("Some Error Occurred!", "info");
        })
        .finally(() => {
          //loader.hide();
        });
    },
    ClearForm() {
      this.dataInvestmentExcel = [];
      this.displayPage = false;
      this.pageErrors = [];
      this.bValidated = false;
    },
  },

  mounted() {
    let self = this;
    let response = self.getLocalInputControls(self.BaseModelInputControl.list);

    self.InvestmentGroupOptions = response.InvestmentGroup;
  }
};
</script>

<style>
.dropzone {
  border: 2px dashed #bbb;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  padding: 25px;
  text-align: center;
  font-size: 16px;
  color: #646464;
  height: 300px !important;
  padding-top: 50px !important;
}
</style>
